(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pool-service-request"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pool-request-form')) {
    customElements.define('pool-request-form', class PoolRequestForm extends HTMLElement {
      connectedCallback() {
        this.enhance = this.enhance.bind(this);
        this.observer = new MutationObserver(this.enhance);
        this.observer.observe(this, { childList: true, subtree: true });
        this.enhance();
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      enhance() {
        const submitLabel = this.getAttribute('data-submit-label');

        this.setSubmitLabel(submitLabel);
        this.setSuccessState();

        this.enhanceField('input[data-type="email"]', {
          autocomplete: 'email',
          enterkeyhint: 'next',
          inputmode: 'email',
          type: 'email'
        });

        this.enhanceField('input[data-type="phone"]', {
          autocomplete: 'tel',
          enterkeyhint: 'next',
          inputmode: 'tel',
          required: 'required',
          type: 'tel'
        });

        this.enhanceField('input[id$="-text"]', {
          autocomplete: 'name',
          enterkeyhint: 'next'
        });

        this.enhanceField('input[id$="-text-1"]', {
          autocomplete: 'street-address',
          enterkeyhint: 'next'
        });
      }

      setSubmitLabel(label) {
        if (!label) {
          return;
        }

        this.querySelectorAll('.globo-formbuilder button[type="submit"], .globo-formbuilder .wizard__submit').forEach((button) => {
          const currentText = button.textContent.replace(/\s+/g, ' ').trim();

          if (button.dataset.poolSubmitLabel === label && currentText === label) {
            return;
          }

          const spinner = button.querySelector('.spinner');

          button.textContent = '';

          if (spinner) {
            button.appendChild(spinner);
          }

          button.appendChild(document.createTextNode(label));
          button.dataset.poolSubmitLabel = label;
          button.dataset.submitText = `<span class="spinner"></span>${label}`;
          button.setAttribute('aria-label', label);
        });
      }

      hasSuccessMessage() {
        return Array.from(this.querySelectorAll('.message.success, .wizard__congrats-message')).some((message) => {
          const text = message.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
          const style = window.getComputedStyle(message);
          const isVisible = style.display !== 'none' && style.visibility !== 'hidden';

          return isVisible && /thank|success|received|submitted|sent|getting in touch/.test(text);
        });
      }

      setSuccessState() {
        const app = this.querySelector('.pool-request__app');
        const successMessage = this.querySelector('.pool-request__success');
        const isSubmitted = this.hasSuccessMessage();

        if (!app || !successMessage) {
          return;
        }

        app.classList.toggle('is-submitted', isSubmitted);
        this.classList.toggle('pool-request--submitted', isSubmitted);
        successMessage.hidden = !isSubmitted;

        if (isSubmitted && successMessage.dataset.poolSuccessFocused !== 'true') {
          successMessage.dataset.poolSuccessFocused = 'true';

          requestAnimationFrame(() => {
            successMessage.focus({ preventScroll: true });
          });
        }
      }

      enhanceField(selector, attributes) {
        this.querySelectorAll(selector).forEach((field) => {
          Object.entries(attributes).forEach(([name, value]) => {
            field.setAttribute(name, value);
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
